import { Translate } from '@chipinside/translate'
import { Stack, SxProps, Theme } from '@mui/material'
import { isEmpty } from 'lodash'

import CowmedChip from '#/components/Chip'
import { TypeLink } from '#/components/FormatCell/Types/link'
import TypeString from '#/components/FormatCell/Types/string'

type Props = {
  value: {
    name?: string
    from_farm: boolean
    archived: boolean
    // TODO: Por hora não vai vir do backend, vai ser discutido link posteriormente
    id?: string
  }
}

const TypeSemenIdentification = ({ value }: Props) => {
  if (isEmpty(value)) return '-'

  const { archived, from_farm, id, name } = value

  const chips = [
    {
      enabled: archived,
      key: 'archived',
      level: 'regular',
      value: Translate({ messageKey: 'archived' }),
    },
    {
      enabled: from_farm,
      key: 'from_farm',
      level: 'warning',
      value: Translate({ messageKey: 'herd' }),
    },
  ] as const

  const link = {
    // enabled: !archived,
    // TODO: Por hora desativado, vai ser discutido link posteriormente
    enabled: false,
    linkTo: 'farm-reproduction-bull-semen-history',
    params: { semen: id },
    value: name,
  } as const

  const sx: SxProps<Theme> = {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 1,
    opacity: archived ? 0.5 : 1,
  }

  return (
    <Stack sx={sx}>
      {link.enabled ? <TypeLink {...link} /> : <TypeString value={name} />}
      {chips
        .filter(chip => chip.enabled)
        .map(chip => (
          <CowmedChip
            width="unset"
            variant="soft"
            value={chip.value}
            tooltip={chip.value}
            level={chip.level}
            key={chip.key}
          />
        ))}
    </Stack>
  )
}

export { TypeSemenIdentification }
